import React, { useState } from 'react';
import { Stack, Textarea, Group, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface RejectReasonFormProps {
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

/**
 * Mandatory-comment form for rejecting a review request. Rendered inside an
 * imperatively-opened Mantine modal (see useReviewRequestsManager).
 */
export const RejectReasonForm: React.FC<RejectReasonFormProps> = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const isEmpty = reason.trim().length === 0;

  return (
    <Stack gap="md">
      <Textarea
        label={t('reviewRequests.rejectReasonLabel')}
        placeholder={t('reviewRequests.rejectReasonPlaceholder')}
        value={reason}
        onChange={(e) => setReason(e.currentTarget.value)}
        error={isEmpty ? t('reviewRequests.rejectReasonRequired') : undefined}
        minRows={3}
        autosize
        data-autofocus
        required
      />
      <Group justify="flex-end" gap="sm">
        <Button variant="light" color="gray" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button color="red" disabled={isEmpty} onClick={() => onConfirm(reason.trim())}>
          {t('reviewRequests.reject')}
        </Button>
      </Group>
    </Stack>
  );
};
